import { Injectable } from '@angular/core';

@Injectable()
export class DownloadService {
  public download(fileName: string, blob: Blob): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);

    try {
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } finally {
      a.remove();
    }
  }
}
